import { render, staticRenderFns } from "./TrainingSourceDescription.vue?vue&type=template&id=9d7f4f12&"
import script from "./TrainingSourceDescription.vue?vue&type=script&lang=js&"
export * from "./TrainingSourceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports